<h1 class="title">Synonymer</h1>
<p class="brodtext-medium-14">
  En synonym används för att identifiera ett okänt namn och relatera det till ett standardnamn för ett smittämne, en <br>
  analys, en provtyp eller ett antibiotika. Varje standardnanm kan ha en eller flera synonymer kopplat till sig.
</p>
<app-button-set [buttons]="synonymerTypesButtonSet" (select)="onSelect($event)"></app-button-set>
<app-table [config]="tableConfig"></app-table>
